let desktopVersion=window.innerWidth>1024 

function clickLevelOneMenu(targetMain) {
  if (targetMain) {
    targetMain.forEach(navigation => {
        navigation.addEventListener("click", (e) => {
            if (navigation.parentElement.classList.contains("active")) {
              navigation.parentElement.classList.remove("active");
            }
            else{
              if (desktopVersion) {
                targetMain.forEach(nav => {
                  nav.parentElement.classList.remove("active");
                });
                navigation.parentElement.classList.add("active");
              }
              else
              {
                  navigation.parentElement.classList.add("active");
              }
            }
        });
    });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const navigationPDM = document.querySelectorAll(".main-navigation-pdm")
  if(navigationPDM)
  {
    const navigationMain = document.querySelectorAll(".main-navigation-pdm .navigation-pdm .nav-link");
    const multiMenus = document.querySelectorAll(".main-navigation-pdm .menu-item-sub");
  
    if (desktopVersion) {
      document.addEventListener('click', function (e) {
          const clickTarget = e.target;
          if(!navigationPDM[0].contains(clickTarget)){
              document.querySelectorAll("#main_nav .navigation-pdm").forEach(nav => {
                  nav.classList.remove("active");
              });
          }    
      });
    }
    clickLevelOneMenu(navigationMain);
    const menusMobile=document.querySelectorAll("#mob_nav .navigation-pdm");
    const hamburMenu=document.querySelector(".hdicon.js-mobile-nav-toggle");
    const subwrapperMenu = document.querySelectorAll(".main-navigation-pdm .submenu-wrapper");

    hamburMenu.addEventListener('click', function (e) {
        menusMobile.forEach(menu => {
            menu.classList.remove("active");
        });
        multiMenus.forEach(menu => {
            menu.classList.remove("active");
        });
        subwrapperMenu.forEach(menu => {
            menu.classList.remove("active");
        });
        menusMobile[0].classList.add("active");
    });
    
    if (multiMenus) {
      const secondMenus = document.querySelectorAll(".navigation-pdm .submenu-wrapper");
      multiMenus.forEach(menu => {
        menu.addEventListener("click", () => {
          let menuHandle = menu.dataset.handle;
          if (desktopVersion)
          {
              multiMenus.forEach(menu => {
                  menu.classList.remove("active");
              });
              menu.classList.add("active");
          }
          else
          {         
              if(menu.classList.contains("active"))
              {
                multiMenus.forEach(menu => {
                    menu.classList.remove("active");
                });
              }  
              else
              {
                multiMenus.forEach(menu => {
                    menu.classList.remove("active");
                });
                menu.classList.add("active");
              }
          }
          if (desktopVersion) {
            secondMenus.forEach(submenu => {
              let submenuHandle = submenu.id;
              submenu.classList.remove("active");
              if(menuHandle===submenuHandle)
              {
                submenu.classList.add("active");
              }  
            });
          }
        });
      });
    }
  }
});